// extracted by mini-css-extract-plugin
module.exports = {"holder":"holder--59VWP","pageId":"pageId--ZdObx","timeSheetsItem":"timeSheetsItem--tO83a","timesheetApproverName":"timesheetApproverName--srzMe","downloadBtn":"downloadBtn--KOXRR"};